import PageShell from '@/components/feature/PageShell';
import HeroSection from './components/HeroSection';
import WhoWeAreSection from './components/WhoWeAreSection';
import ExpertiseSection from './components/ExpertiseSection';
import DarkChapter from './components/DarkChapter';
import ClientPerspectivesSection from './components/ClientPerspectivesSection';
import MeetPeopleSection from './components/MeetPeopleSection';
import FinalCtaSection from './components/FinalCtaSection';
import ThemeChapter from './components/ThemeChapter';

export default function Home() {
  return (
    <PageShell
      title="Morrow People | Independent HR & Talent Advisory"
      description="Morrow People is an independent HR and talent advisory partner helping ambitious organisations find exceptional people, make confident decisions and build stronger teams."
    >
      <div className="theme-orange bg-background-50 text-foreground-950">
        <HeroSection />
      </div>
      <WhoWeAreSection />
      <ThemeChapter>
        <ExpertiseSection />
        <DarkChapter />
        <ClientPerspectivesSection />
        <MeetPeopleSection />
      </ThemeChapter>
      <FinalCtaSection />
    </PageShell>
  );
}